webpackJsonp([142629428675168],{

/***/ 892:
/***/ (function(module, exports) {

	module.exports = {"data":{"site":{"siteMetadata":{"facebook":{"appId":""}}}},"pathContext":{}}

/***/ })

});


// WEBPACK FOOTER //
// path---index-206ac74de0d3aab26f03.js